// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./parchment.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic two-column layout */
.basic-layout {
  display: flex;
  height: calc(95vh - 65px); /* Reduced from 100vh to 90vh (10% reduction) */
  overflow: hidden;
  padding: 20px;
  background-color: #f5f5f5;
}

/* Left column - chat interface */
.text-column {
  width: 50%;
  padding: 0;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.6); /* Add white with 90% opacity */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: overlay; /* Blend the color with the image */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-right: 20px;
}

.chat-header {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background-color: #fff;
  border-bottom: 1px solid rgba(135, 134, 127, 0.25);
  gap: 16px;
}

.chat-header-avatar {
  width: 40px;
  height: 40px;
  background-color: #faf8f5;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(135, 134, 127, 0.25);
}

.chat-header-content {
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 40px; /* Adjusted to not overlap with the disclaimer */
}

.message {
  display: flex;
  margin-bottom: 12px;
}

.user-message {
  justify-content: flex-end;
  background-color: transparent;
}

.assistant-message {
  justify-content: flex-start;
  background-color: transparent;
}

.message-content {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 12px;
  word-break: break-word;
  font-family: 'Crimson', serif;
  font-size: 16px;
}

.user-message .message-content {
  background-color: #ded8d1;
  color: #000;
  text-align: left;
  font-family: "Gabarito", serif;
  font-size: 14px;
}

.assistant-message .message-content {
  background-color: #fff;
  color: #000;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
  position: relative;
  padding-left: 40px;
}

.assistant-message .message-content::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 11px;
  width: 20px;
  height: 20px;
  background-color: #b19f95;
  border-radius: 50px;
}

.assistant-message .message-content::after {
  position: absolute;
  left: 17px;
  top: 11px;
  z-index: 1;
  display: inline-block;
  width: 16px;
  height: 16px;
  font-size: 14px;
  content: "C";
  font-family: "Gabarito", serif;
}

.loading-message {
  display: flex;
  align-items: center; /* This centers the dots vertically */
  justify-content: flex-start;
  height: 24px; /* Ensure consistent height */
  margin: 5px 0; /* Add some vertical spacing */
}

.loading-message div {
  width: 8px;
  height: 8px;
  margin-right: 5px;
  background-color: #ccc;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out both;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.2);
  }
}

.chat-input-container {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  box-shadow: 0px 5px 20px 0px #ded8d1;
  padding: 12px;
  border-radius: 16px;
  margin: 16px;
  gap: 8px;
  font-family: "Gabarito", serif;
}

.chat-input-container input {
  flex: 1 1;
  padding: 8px;
  border: none;
  outline: none;
  font-family: "Gabarito", serif;
}

.chat-input-container button {
  border: none;
  background-color: #df2d11;
  color: #fff;
  border-radius: 12px;
  cursor: pointer;
  padding: 8px 12px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-input-container button:hover {
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
}

/* Right column - image only */
.image-column {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.6); /* Add white with 90% opacity */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: overlay; /* Blend the color with the image */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-left: 10px;
}

.feature-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 8px;
}

/* Add to Explore.css */
.image-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.generated-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

.generated-image {
  object-fit: contain;
  max-height: calc(100% - 50px);
  border-radius: 8px;
  transition: transform 0.3s ease;
  box-shadow: none;
}

/* Travel header row */
.travel-header-row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

/* Responsive styles */
@media (max-width: 768px) {
  .basic-layout {
    flex-direction: column;
    height: auto;
  }
  
  .text-column,
  .image-column {
    width: 100%;
    margin: 0 0 20px 0;
  }
  
  .text-column {
    height: 70vh;
  }
  
  .image-column {
    order: -1; /* Image appears first on mobile */
    max-height: 30vh;
  }
}

.go-button {
  background-color: #df2d11 !important;
  color: white !important;
  margin-left: 30px; /* Increased from 20px to 30px to move it more to the right */
  border: none;
  border-radius: 12px;
  cursor: pointer;
  padding: 8px 12px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.disclaimer-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  color: #BBBBBB;
  text-align: center;
  font-size: 10px;
  font-family: 'Gabarito', sans-serif;
  z-index: 100; /* Changed from 100 to -1 to position behind other elements */
  padding: 6px 0 7px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Travel/Travel.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB,EAAE,+CAA+C;EAC1E,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0CAA0C,EAAE,+BAA+B;EAC3E,yDAAyC;EACzC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B,EAAE,mCAAmC;EACnE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB,EAAE,gDAAgD;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,qCAAqC;EAC1D,2BAA2B;EAC3B,YAAY,EAAE,6BAA6B;EAC3C,aAAa,EAAE,8BAA8B;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0CAA0C,EAAE,+BAA+B;EAC3E,yDAAyC;EACzC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B,EAAE,mCAAmC;EACnE,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS,EAAE,kCAAkC;IAC7C,gBAAgB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB,EAAE,6DAA6D;EAChF,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,YAAY,EAAE,6DAA6D;EAC3E,kBAAkB;AACpB","sourcesContent":["/* Basic two-column layout */\n.basic-layout {\n  display: flex;\n  height: calc(95vh - 65px); /* Reduced from 100vh to 90vh (10% reduction) */\n  overflow: hidden;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n/* Left column - chat interface */\n.text-column {\n  width: 50%;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(255, 255, 255, 0.6); /* Add white with 90% opacity */\n  background-image: url('./parchment.webp');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-blend-mode: overlay; /* Blend the color with the image */\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  margin-right: 20px;\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n  gap: 16px;\n}\n\n.chat-header-avatar {\n  width: 40px;\n  height: 40px;\n  background-color: #faf8f5;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.chat-header-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-messages {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 40px; /* Adjusted to not overlap with the disclaimer */\n}\n\n.message {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.user-message {\n  justify-content: flex-end;\n  background-color: transparent;\n}\n\n.assistant-message {\n  justify-content: flex-start;\n  background-color: transparent;\n}\n\n.message-content {\n  max-width: 80%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  word-break: break-word;\n  font-family: 'Crimson', serif;\n  font-size: 16px;\n}\n\n.user-message .message-content {\n  background-color: #ded8d1;\n  color: #000;\n  text-align: left;\n  font-family: \"Gabarito\", serif;\n  font-size: 14px;\n}\n\n.assistant-message .message-content {\n  background-color: #fff;\n  color: #000;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);\n  position: relative;\n  padding-left: 40px;\n}\n\n.assistant-message .message-content::before {\n  content: '';\n  position: absolute;\n  left: 12px;\n  top: 11px;\n  width: 20px;\n  height: 20px;\n  background-color: #b19f95;\n  border-radius: 50px;\n}\n\n.assistant-message .message-content::after {\n  position: absolute;\n  left: 17px;\n  top: 11px;\n  z-index: 1;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  font-size: 14px;\n  content: \"C\";\n  font-family: \"Gabarito\", serif;\n}\n\n.loading-message {\n  display: flex;\n  align-items: center; /* This centers the dots vertically */\n  justify-content: flex-start;\n  height: 24px; /* Ensure consistent height */\n  margin: 5px 0; /* Add some vertical spacing */\n}\n\n.loading-message div {\n  width: 8px;\n  height: 8px;\n  margin-right: 5px;\n  background-color: #ccc;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(1);\n  }\n  40% {\n    transform: scale(1.2);\n  }\n}\n\n.chat-input-container {\n  display: flex;\n  align-items: center;\n  background-color: #FFFFFF;\n  box-shadow: 0px 5px 20px 0px #ded8d1;\n  padding: 12px;\n  border-radius: 16px;\n  margin: 16px;\n  gap: 8px;\n  font-family: \"Gabarito\", serif;\n}\n\n.chat-input-container input {\n  flex: 1;\n  padding: 8px;\n  border: none;\n  outline: none;\n  font-family: \"Gabarito\", serif;\n}\n\n.chat-input-container button {\n  border: none;\n  background-color: #df2d11;\n  color: #fff;\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 8px 12px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chat-input-container button:hover {\n  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* Right column - image only */\n.image-column {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background-color: rgba(255, 255, 255, 0.6); /* Add white with 90% opacity */\n  background-image: url('./parchment.webp');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-blend-mode: overlay; /* Blend the color with the image */\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  margin-left: 10px;\n}\n\n.feature-image {\n  max-width: 90%;\n  max-height: 90%;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n/* Add to Explore.css */\n.image-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.generated-image-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.generated-image {\n  object-fit: contain;\n  max-height: calc(100% - 50px);\n  border-radius: 8px;\n  transition: transform 0.3s ease;\n  box-shadow: none;\n}\n\n/* Travel header row */\n.travel-header-row {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .basic-layout {\n    flex-direction: column;\n    height: auto;\n  }\n  \n  .text-column,\n  .image-column {\n    width: 100%;\n    margin: 0 0 20px 0;\n  }\n  \n  .text-column {\n    height: 70vh;\n  }\n  \n  .image-column {\n    order: -1; /* Image appears first on mobile */\n    max-height: 30vh;\n  }\n}\n\n.go-button {\n  background-color: #df2d11 !important;\n  color: white !important;\n  margin-left: 30px; /* Increased from 20px to 30px to move it more to the right */\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 8px 12px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.disclaimer-footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: transparent;\n  color: #BBBBBB;\n  text-align: center;\n  font-size: 10px;\n  font-family: 'Gabarito', sans-serif;\n  z-index: 100; /* Changed from 100 to -1 to position behind other elements */\n  padding: 6px 0 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
